<template>
  <div class="mb-3 w-full md:w-134 md:mx-auto input">
    <div class="flex relative">
      <slot />
      <input
        :name="name"
        :value="value"
        :class="[
          themeIsDark
            ? 'bg-transparent placeholder-gray-200 focus:shadow-none focus:ring-transparent'
            : 'bg-white placeholder-gray-300 focus:shadow-none focus:ring-transparent',
          hintState === 'error'
            ? 'border-red-500 focus:border-red-500 '
            : themeIsDark
            ? 'border-white focus:border-white'
            : 'border-gray-300 focus:border-gray-300 ',
        ]"
        class="
          border
          rounded-md
          block
          w-full
          py-5
          px-6
          text-base
          leading-tight
          focus:shadow-none focus:ring-transparent focus:border-white
        "
        :type="type"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
      />
    </div>
    <div
      v-if="hint && hintState === 'error'"
      :class="hintTextColor[hintState]"
      class="flex text-xs mt-px mb-2 text-left items-center hint"
    >
      <!-- <Icon v-if="hintState == 'success'" id="inputSuccess" class="inline" /> -->
      <!-- <Icon v-if="hintState == 'error'" id="inputError" class="inline" /> -->
      <span class="">{{ hint }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component({
  components: {
  }
})
export default class InputText extends Vue {
  @Prop() value!: string
  @Prop({ default: 'default' }) hintState!: 'error' | 'default' | 'success'
  @Prop() type!: 'text' | 'tel' | 'email' | 'password'
  @Prop() placeholder!: string
  @Prop() hint!: string
  @Prop() name!: string
  @Getter themeIsDark!: boolean

  hintTextColor = {
    error: 'text-red-500',
    success: 'text-green-500'
  }
}
</script>
